import { Box, Paper, TableCell, TableRow } from '@material-ui/core';
import styled from 'styled-components';

export const ClickableRow = styled(TableRow)`
  cursor: pointer;
`;

export const NoWrapCell = styled(TableCell)`
  white-space: nowrap;
`;

export const Page = styled(Box)`
  padding: 24px;
`;

export const Toolbar = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const Filters = styled(Paper)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  padding: 16px;
  margin-bottom: 20px;
`;

export const FormPaper = styled(Paper)`
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin: 24px 0;
`;

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

export const DetailItem = styled.div`
  padding: 8px 0;
`;

export const Conditions = styled.pre`
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  margin: 0;
`;

// Secondary line under a table cell value (contract type, status hints).
export const CellNote = styled.span`
  display: block;
  font-size: 0.75rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.54);
  white-space: nowrap;
`;

// The order subject under the client in the consultant's list; it may be long,
// so it wraps instead of widening the table.
export const SubjectNote = styled(CellNote)`
  white-space: normal;
  max-width: 360px;
`;

// Inline editor for one bulk-issue row.
export const RowEditor = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
  padding: 8px 0;
`;

// Arrow of a bubble anchored to a button; the popper positions it along the
// edge, the bubble's placement decides which edge.
export const BubbleArrow = styled.span`
  position: absolute;
  width: 20px;
  height: 10px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
  }
`;

// Confirmation bubble shown above (or, without room, below) its button.
export const RejectBubble = styled(Paper)`
  position: relative;
  max-width: 360px;
  padding: 16px;
  margin: 10px 0;

  &[data-placement^='top'] ${BubbleArrow} {
    bottom: -10px;

    &::before {
      border-width: 10px 10px 0 10px;
      border-color: #fff transparent transparent transparent;
    }
  }

  &[data-placement^='bottom'] ${BubbleArrow} {
    top: -10px;

    &::before {
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent #fff transparent;
    }
  }
`;

// Helper text with a message on the left and a character counter on the right.
export const HelperRow = styled.span`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
